import React from "react";

const DataTableContext = React.createContext({});

export { DataTableContext };
